var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "234px",
    height: "166px",
    viewBox: "0 0 234 166",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "50B9D8FF-1696-486A-A2E2-B78F529EBAA2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,23 L0,159.000082 C0,160.656891 1.35070309,162 2.99216995,162 L227.00783,162 C228.66036,162 230,160.657765 230,159.000082 L230,23 L0,23 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.7%",
    y: "-1.4%",
    width: "103.5%",
    height: "105.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.15 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V2-(Release-1)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Error-(General)",
    transform: "translate(-581.000000, -201.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Message",
    transform: "translate(346.000000, 161.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Browser",
    transform: "translate(237.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.99216995,0 C1.33964012,0 0,1.33599155 0,3.00684834 L0,23 L230,23 L230,3.00684834 C230,1.34621185 228.649297,0 227.00783,0 L2.99216995,0 Z",
    id: "background",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "object",
    fill: "#FFFFFF",
    cx: 23,
    cy: 12,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,16 C36.209139,16 38,14.209139 38,12 C38,9.790861 36.209139,8 34,8 C31.790861,8 30,9.790861 30,12 C30,14.209139 31.790861,16 34,16 Z",
    id: "object",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "object",
    fill: "#FFFFFF",
    cx: 45,
    cy: 12,
    r: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "001-warning",
    transform: "translate(94.000000, 87.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "003-warning",
    transform: "translate(75.000000, 55.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.5278863,57.2006208 L50.2539207,6.51509079 C48.1439324,2.78441142 44.2981017,0.5 39.9841309,0.5 C35.6701598,0.5 31.8249397,2.78501829 29.7149513,6.51509079 L1.47211375,57.2006208 C-0.543880339,60.8378359 -0.496883242,65.1742121 1.66010229,68.7646951 C3.77009058,72.3551781 7.56831373,74.5 11.7419037,74.5 L68.2580963,74.5 C72.4316863,74.5 76.2299094,72.3551781 78.3398977,68.7646951 C80.4968832,65.1742121 80.5438803,60.8378359 78.5278863,57.2006208 Z",
    id: "Path",
    fill: "#FFC441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3405561,68.7646951 C76.2314045,72.3551781 72.4346876,74.5 68.2627528,74.5 L40,74.5 L40,0.5 C44.31226,0.5 48.1565656,2.78501829 50.2657171,6.51509079 L78.52847,57.2006208 C80.5436647,60.8378359 80.4966862,65.1742121 78.3405561,68.7646951 Z",
    id: "Path",
    fill: "#E6B03A"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "35 53.5 44 53.5 44 62.5 35 62.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#CCCCCC",
    points: "40 53.5 45 53.5 45 62.5 40 62.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "35 21.5 44 21.5 44 44.5 35 44.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#CCCCCC",
    points: "40 21.5 45 21.5 45 44.5 40 44.5"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorLogo);
export default __webpack_public_path__ + "static/media/errorLogo.341ca74f5a53a1c936df0fd306be246f.svg";
export { ForwardRef as ReactComponent };